import { Brand } from "../Model/Brand";
import { BrandRepository } from "../Repository/BrandRepository";

export interface CreateBrandUseCase {
  invoke: (data: Brand) => Promise<Brand[]>;
}

export class CreateBrand implements CreateBrandUseCase {

  private BrandRepo: BrandRepository;

  constructor(_BrandRepo: BrandRepository) {
    this.BrandRepo = _BrandRepo;
  }

  async invoke(data: Brand){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.BrandRepo.createBrand(data);
    return created;
  }
}